import {useEffect} from "react";
import {Outlet, useLocation} from "react-router-dom";
import {openAccountModal} from "@/accountModal";
import {PublicHeader} from "@/components/PublicHeader";
import {useAuthBootstrap} from "@/hooks/useAuthBootstrap";
import {useLandingAuth} from "@/state/authStore";

export function CabinetLayout() {
    const {status} = useAuthBootstrap();
    const user = useLandingAuth((s) => s.user);
    const location = useLocation();
    const viewingHistory = location.pathname.includes("/history");
    const cancellationConfirmed = location.pathname.includes("/subscription/cancelled");
    const pauseConfirmed = location.pathname.includes("/subscription/paused");
    const unfreezeConfirmed = location.pathname.includes("/subscription/unfrozen");
    const unfreezingSubscription = location.pathname.includes("/subscription/unfreeze");
    const freezingSubscription = location.pathname.includes("/subscription/cancel/freeze");
    const cancellingSubscription = location.pathname.includes("/subscription/cancel");

    useEffect(() => {
        if (status === "unauthenticated") {
            void openAccountModal("signin");
        }
    }, [status]);

    if (status === "loading") {
        return (
            <>
                <PublicHeader user={user}/>
                <div className="cabinet-screen">
                    <div className="cabinet-state">
                        <h2>Загружаем кабинет</h2>
                        <p>Проверяем авторизацию и статус подписки.</p>
                    </div>
                </div>
            </>
        );
    }

    if (status === "error") {
        return (
            <>
                <PublicHeader user={user}/>
                <div className="cabinet-screen">
                    <div className="cabinet-state">
                        <h2>Не удалось войти</h2>
                        <p>Повторите вход через Telegram.</p>
                        <button className="btn btn-primary" type="button" onClick={() => void openAccountModal("signin")}>
                            Подключить Telegram
                        </button>
                    </div>
                </div>
            </>
        );
    }

    if (status === "unauthenticated" || !user) {
        return (
            <>
                <PublicHeader user={null}/>
                <div className="cabinet-screen">
                    <div className="cabinet-state">
                        <h2>Войдите в Лидхолд</h2>
                        <p>Авторизуйтесь, чтобы открыть личный кабинет.</p>
                        <button className="btn btn-primary" type="button" onClick={() => void openAccountModal("signin")}>
                            Войти
                        </button>
                    </div>
                </div>
            </>
        );
    }

    const pageTitle = viewingHistory
        ? "История операций"
        : cancellationConfirmed
            ? "Автопродление отключено"
            : pauseConfirmed
                ? "Подписка на паузе"
                : unfreezeConfirmed
                    ? "Подписка возобновлена"
                    : unfreezingSubscription
                        ? "Подписка на паузе"
                        : freezingSubscription
                            ? "Приостановка подписки"
                            : cancellingSubscription
                                ? "Отмена подписки"
                                : "Возможности подписки";

    return (
        <>
            <PublicHeader user={user}/>
            <div className="cabinet-screen">
                <header className="cabinet-top">
                    <div>
                        <div className="cabinet-kicker">Личный кабинет</div>
                        <h1 className="cabinet-title">{pageTitle}</h1>
                    </div>
                    <a className="btn btn-muted cabinet-home-link" href="/">
                        На главную
                    </a>
                </header>

                <main className="cabinet-main">
                    <Outlet/>
                </main>
            </div>
        </>
    );
}
